import { IBatchExportFileResponse } from "../interfaces/ap-workflow";
import authBaseAxios from "../utils/api";

export const BatchServices = {

  onDownloadBatchExport: (batchId: number): Promise<IBatchExportFileResponse> => {
    return authBaseAxios.get(`/batches/${batchId}/download-export-file`);
  },
};